import jamesFull from '../resources/apps/james-full.png'
import jamesIcon from '../resources/apps/james-icon.png'
import veeverFull from '../resources/apps/veever-full.png'
import veeverIcon from '../resources/apps/veever-icon.png'
import superpadsFull from '../resources/apps/superpads-full.png'
import superpadsIcon from '../resources/apps/superpads-icon.png'
import jumpoFull from '../resources/apps/jumpo-full.png'
import jumpoIcon from '../resources/apps/jumpo-icon.png'

const apps = [
  {
    name: 'James Delivery',
    description:
      'Criado por 3 estudantes que se tornaram sócios do negócio, o app nasceu durante um Macro Challenge da Academy e cresceu até operar em mais de 35 cidades!',
    page: jamesFull,
    icon: jamesIcon,
    link: 'https://www.jamesdelivery.com.br/',
  },
  {
    name: 'Veever',
    description:
      'Um app com impacto social, que usando microlocalização, ajuda pessoas com deficiência visual a se orientar em espaços físicos. Já foi usado para acessibilidade em grandes eventos, como o Rock in Rio 2019, um dos maiores festivais do mundo!',
    page: veeverFull,
    icon: veeverIcon,
    link: 'https://apps.apple.com/tn/app/veever/id1488816979',
  },
  {
    name: 'SuperPads',
    description:
      'Nasceu da paixão de um estudante por música e se tornou um fenômeno: mais de 120 milhões de downloads, colocando o app entre os mais baixados do mundo em sua categoria, no mesmo patamar de apps de grandes estúdios internacionais!',
    page: superpadsFull,
    icon: superpadsIcon,
    link: 'https://apps.apple.com/br/app/super-pads-seja-um-dj/id1196953001',
  },
  {
    name: 'jump-O',
    description:
      'Criado por dois alunos em um Mini Challenge, este jogo de arte minimalista venceu o Apple Design Award em 2015 (considerado o "Oscar" do design de apps), entregue anualmente pela Apple a poucos aplicativos em todo o mundo!',
    page: jumpoFull,
    icon: jumpoIcon,
    link: 'https://www.youtube.com/watch?v=nwCWdQz3ZRY',
  },
]

export default apps
